export const deductionTable = () => {
  return [
    {
      field: 'sl_no',
      headerName: 'SL.No',
      width: 80,
      headerAlign: 'left',
      align: 'left',
    },
    {
      field: 'student_name',
      headerName: 'Student Name',
      width: 220,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'admn_no',
      headerName: 'ADM No',
      width: 130,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'total_sales_amount',
      headerName: 'Total Sale Amount',
      width: 200,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'session_completed_deduction',
      headerName: 'Deduction - Session Completed',
      width: 220,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'gst_deduction',
      headerName: 'Deduction - GST',
      width: 180,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'admission_fee_deduction',
      headerName: 'Deduction - Adm Fee',
      width: 170,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'net_refund_paid',
      headerName: 'Net Refund Paid',
      width: 180,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'total_fee_collected',
      headerName: 'Fee Collected',
      width: 180,
      headerAlign: 'center',
      align: 'center',
    },
  ];
};
